module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-flex', {
    attrs: {
      "xs12": "",
      "sm10": "",
      "md8": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "pa-4"
  }, [(_vm.err) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "error"
    }
  }, [_vm._v(_vm._s(_vm.err))])], 1) : _vm._e(), _vm._v(" "), (_vm.success) ? _c('v-flex', {
    attrs: {
      "xs12": "",
      "pb-3": ""
    }
  }, [_c('v-alert', {
    attrs: {
      "value": true,
      "type": "success"
    }
  }, [_vm._v(_vm._s(_vm.success))])], 1) : _vm._e(), _vm._v(" "), _c('v-form', {
    model: {
      value: (_vm.valid),
      callback: function($$v) {
        _vm.valid = $$v
      },
      expression: "valid"
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [(!_vm.isLocalAdmin) ? _c('v-autocomplete', {
    attrs: {
      "items": _vm.companies,
      "label": _vm.$lang.actions.selectCompany,
      "item-text": "name",
      "item-value": "id",
      "required": "",
      "readonly": _vm.isEdit,
      "loading": _vm.companyLoading,
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingCompany)); }]
    },
    model: {
      value: (_vm.printServer.companyId),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "companyId", $$v)
      },
      expression: "printServer.companyId"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.printServerName,
      "required": "",
      "rules": [function (v) { return !!v || ("" + (_vm.$lang.errors.missingPrintServerName)); }]
    },
    model: {
      value: (_vm.printServer.name),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "name", $$v)
      },
      expression: "printServer.name"
    }
  })], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-autocomplete', {
    attrs: {
      "chips": "",
      "deletable-chips": "",
      "multiple": "",
      "items": _vm.mappedPrinters,
      "label": _vm.$lang.actions.selectPrinters,
      "required": "",
      "disabled": _vm.mappedPrinters.length === 0,
      "loading": _vm.printersLoading,
      "rules": [function () { return _vm.printServer.printers.length > 0 || ("" + (_vm.$lang.errors.missingPrinters)); }]
    },
    model: {
      value: (_vm.printServer.printers),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "printers", $$v)
      },
      expression: "printServer.printers"
    }
  })], 1), _vm._v(" "), (_vm.isEdit) ? _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-textarea', {
    attrs: {
      "id": "key",
      "label": _vm.$lang.labels.key,
      "auto-grow": "",
      "rows": "1",
      "readonly": _vm.isEdit
    },
    model: {
      value: (_vm.printServer.printServerKey),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "printServerKey", $$v)
      },
      expression: "printServer.printServerKey"
    }
  })], 1) : _vm._e(), _vm._v(" "), _c('v-flex', {
    attrs: {
      "xs12": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": _vm.$lang.labels.records,
      "type": "number",
      "min": "1",
      "max": "128"
    },
    model: {
      value: (_vm.printServer.fetchRecordsLimit),
      callback: function($$v) {
        _vm.$set(_vm.printServer, "fetchRecordsLimit", _vm._n($$v))
      },
      expression: "printServer.fetchRecordsLimit"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    staticClass: "mt-3",
    attrs: {
      "row": "",
      "wrap": "",
      "justify-space-between": "",
      "align-content-center": ""
    }
  }, [_c('v-btn', {
    staticClass: "ml-0",
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        return _vm.$router.push({
          name: 'printServers'
        })
      }
    }
  }, [_c('v-icon', [_vm._v("keyboard_arrow_left")]), _vm._v("\n          " + _vm._s(_vm.$lang.actions.close) + "\n        ")], 1), _vm._v(" "), _c('div', [(_vm.isEdit) ? _c('v-btn', {
    staticClass: "primary",
    on: {
      "click": _vm.copyKey
    }
  }, [_vm._v("\n            " + _vm._s(_vm.$lang.actions.copyKey) + "\n          ")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
    staticClass: "primary mx-0",
    attrs: {
      "disabled": !_vm.valid
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("\n            " + _vm._s(_vm.isEdit ? _vm.$lang.actions.update : _vm.$lang.actions.create) + "\n          ")])], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3703eb3f","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/printServers/PrintServerDetails.vue
// module id = 397
// module chunks = 35